import axios from "axios";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../components/auth/login/GetCookie";
const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [readNotifications, setReadNotifications] = useState(new Set());
  const [loading, setLoading] = useState(false)
  //   const [read]=useState(null)
  const navigate = useNavigate();





  useEffect(() => {
    fetchnotification();
    // const interval = setInterval(fetchnotification, 5000); // Poll every 5s
    // return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const fetchnotification = async () => {
    // const token = localStorage.getItem('token');
    const token = getCookie("token");

    // if (!token) {
    //   toast.error("Invalid token");
    //   return;
    // }



    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const allNotifications = response.data;

      // Filter only INQUIRY_REPLY notifications
      const filteredNotifications = allNotifications.filter(
        (notif) => notif.notificationType === "INQUIRY_REPLY"
      );



      if (Array.isArray(filteredNotifications)) {
        console.log("Notification IDs:", filteredNotifications.map((notif) => notif.notificationId));
        console.log("Notification status:", filteredNotifications.map((notif) => notif.read));
      }
      setNotifications(filteredNotifications);

    } catch (error) {
      console.error("Error Fetching Notification:", error);
    } finally {
      setLoading(false);
    }
  };


  const markAsRead = async (notificationId) => {
    const notification = notifications.find((notif) => notif.notificationId === notificationId);

    if (!notification) {
      toast.error("Notification not found!");
      return;
    }

    if (notification.read) {
      toast.error("Already marked as read.");
      return;
    }

    try {
      // const token = localStorage.getItem('token');
      const token = getCookie("token");
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications/${notificationId}/mark-read`,
        {}, // Assuming no body is required
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Update local state after successful API call
      setNotifications((prev) =>
        prev.map((notif) =>
          notif.notificationId === notificationId ? { ...notif, read: true } : notif
        )
      );

      setReadNotifications((prev) => {
        const updatedRead = new Set(prev).add(notificationId);
        localStorage.setItem("readNotifications", JSON.stringify([...updatedRead]));
        return updatedRead;
      });

      toast.success("Notification marked as read!");
    } catch (error) {
      console.error("Error marking notification as read:", error);
      toast.error("Failed to mark notification as read.");
    }
  };
  return (
    <div className="common-margin ">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="d-flex   ms-5 px-lg-4 px-md-4 align-item-center gap-2  pt-4 justify-content-left">

        <Icon
          icon={'material-symbols:arrow-back-rounded'}
          style={{ cursor: 'pointer', color: '#606060' }}
          className="fs-4 mt-1 cursor-pointer"
          onClick={() => navigate(-1)}
        />

        <h1 className="text-left heading-enquiries">Notification</h1>
      </div>




      {/* <div className="row ">
    <div className="col-md-12"> */}
      <div className="row notification gx-0 gy-0 "
        // style={{
        //   maxHeight:'100%'
        // //  marginBottom:'230px'
        // }}
        style={{
          minHeight: "calc(100vh - 350px)", // Adjust 100px based on your header or margin
          display: notifications.length === 0 && !loading ? "flex" : "block",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="col-10 col-md-12  col-lg-12 ">
          <ul className="list-unstyled mx-lg-5 mx-md-5">
            {loading ? (
              // Ghost Loading Skeletons
              Array.from({ length: 4 }).map((_, index) => (
                <li key={index} className="d-flex align-items-center py-2 px-0">
                  {/* Placeholder Dot */}
                  <div
                    className="me-3 skeleton"
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: "#E0E0E0",
                    }}
                  ></div>

                  {/* Placeholder Icon */}
                  <div className="me-2 align-self-start" >
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center skeleton"
                      style={{ width: "52px", height: "52px", background: "#F0F0F0" }}
                    ></div>
                  </div>

                  {/* Placeholder Text */}
                  <div className="w-100">
                    <div className="px-2">
                      <div className="skeleton" style={{ width: "70%", height: "16px", background: "#E0E0E0" }}></div>
                      <div className="skeleton mt-2" style={{ width: "90%", height: "14px", background: "#F0F0F0" }}></div>
                      <div className="skeleton mt-2" style={{ width: "40%", height: "12px", background: "#D0D0D0" }}></div>
                      <div className="skeleton mt-2" style={{ width: "40%", height: "12px", background: "#D0D0D0" }}></div>
                    </div>
                  </div>
                </li>
              ))
            ) :
              notifications.length > 0 ? (
                notifications.map((n, index) => (
                  <li
                    key={n.notificationId} // Using a stable key
                    // className="d-flex align-items-center py-2 px-0 "
                    className="d-flex align-items-start py-2 px-3 px-lg-0 "
                    style={{
                      cursor: 'pointer',
                      // marginBottom: index === notifications.length < 2 ? '0px' : '0px',
                    }}
                    onClick={() => markAsRead(n.notificationId)}
                  >
                    {/* Dot Placeholder - Keeps Space Even if Read */}
                    <div
                      className="me-3   Notification-dot "
                      style={{

                        // backgroundColor:'red'
                        backgroundColor: n.read ? "transparent" : "#FDC400",
                      }}
                    ></div>

                    {/* Icon - Aligned to Top */}
                    <div className="me-2 align-self-start mt-1">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "52px",
                          height: "52px",
                          background: "#fffbea",
                        }}
                      >
                        {n.notificationType === "NEW_PRODUCT" ? (
                          <Icon icon="ph:package" className="fs-4" style={{ color: "#371300" }} />
                        ) : (
                          <Icon icon="carbon:document" className="fs-4" style={{ color: "#371300" }} />
                        )}
                      </div>
                    </div>

                    {/* Notification Content - Centered */}
                    <div className="w-100 d-flex align-items-center justify-content-between">
                      <div className="px-2">
                        <p
                          className="msg-title m-0"
                          style={{
                            color: readNotifications.has(n.notificationId) ? "#303030" : "#371300",
                          }}
                        >
                          {n.notificationType === "INQUIRY_REPLY" ? "Reply Received!" : ""}
                        </p>
                        <p className="small text-muted m-0">{n.message}</p>
                        <p className="small" style={{ color: "#A1A1A1" }}>
                          {new Date(n.createdAt).toLocaleString("en-US", {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                            day: "2-digit",
                            month: "short",
                            year: "2-digit",
                          }).replace(",", "")}
                        </p>
                      </div>
                    </div>

                    {/* Delete Icon
                        <Icon
                            icon="material-symbols:delete-outline"
                            className="fs-4 mx-1"
                            style={{
                                color: "#C0C0C0",
                                cursor: "pointer",
                            }}
                        /> */}
                  </li>
                ))
              ) : (
                <p className="text-muted text-center">No notifications</p>
              )}
          </ul>
        </div>
      </div>



    </div>
  );
};
export default Notification;